import './shared/lib/sentry/sentry';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { lazy, Suspense, StrictMode } from 'react';

import { QueryProvider } from './shared/api/query-provider';
import { KcPage, type KcContext } from './features/auth/keycloak-theme/kc.gen';

const AppEntrypoint = lazy(() => import('./main.app'));

const rootOptions: Parameters<typeof createRoot>[1] = import.meta.env.PROD
  ? {
      onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
      }),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }
  : undefined;

createRoot(document.getElementById('root')!, rootOptions).render(
  <StrictMode>
    {window.kcContext ? (
      <QueryProvider>
        <KcPage kcContext={window.kcContext} />
      </QueryProvider>
    ) : (
      <Suspense>
        <AppEntrypoint />
      </Suspense>
    )}
  </StrictMode>
);

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}
